module.exports = __webpack_public_path__ + "img/profil_lapper_bareiere.2669d21b.png";